//export const hexArr = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0A', '0B', '0C', '0D', '0E', '0F', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1A', '1B', '1C', '1D', '1E', '1F', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2A', '2B', '2C', '2D', '2E', '2F', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3A', '3B', '3C', '3D', '3E', '3F', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4A', '4B', '4C', '4D', '4E', '4F', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5A', '5B', '5C', '5D', '5E', '5F', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6A', '6B', '6C', '6D', '6E', '6F', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7A', '7B', '7C', '7D', '7E', '7F', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8A', '8B', '8C', '8D', '8E', '8F', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9A', '9B', '9C', '9D', '9E', '9F', 'A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'C0', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'CA', 'CB', 'CC', 'CD', 'CE', 'CF', 'D0', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8', 'D9', 'DA', 'DB', 'DC', 'DD', 'DE', 'E0', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7', 'E8', 'E9', 'EA', 'EB', 'EC', 'ED', 'EE', 'EF', 'F0', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'FA', 'FB', 'FC', 'FD', 'FE', 'FF'];
//export const nonPrintable = ['Null', 'Start of Head', 'Start of Text', 'End of Text', 'End of Transmission', 'Enquiry', 'Acknowledge', 'Audible Bell', 'Backspace', 'Horizontal Tab', 'Line Feed', 'Vertical Tab', 'Form Feed', 'Carriage Return', 'Shift Out', 'Shift In', 'Data Line Esc.', 'Device Control 1', 'Device Control 2', 'Device Control 3', 'Device Control 4', 'Negative ACK', 'Synch. Idle', 'End Transmission Block', 'Cancel', 'End Of Medium', 'Substitution', 'Escape', 'Figures Shift', 'Group Separator', 'Record Separator', 'Unit Separator', 'Blank Space'];

export const delimiters = [
  {
      "hex": "00",
      "char": "\u0000",
      "display": "Null",
  },
  {
      "hex": "01",
      "char": "\u0001",
      "display": "Start of Head"
  },
  {
      "hex": "02",
      "char": "\u0002",
      "display": "Start of Text"
  },
  {
      "hex": "03",
      "char": "\u0003",
      "display": "End of Text"
  },
  {
      "hex": "04",
      "char": "\u0004",
      "display": "End of Transmission"
  },
  {
      "hex": "05",
      "char": "\u0005",
      "display": "Enquiry"
  },
  {
      "hex": "06",
      "char": "\u0006",
      "display": "Acknowledge"
  },
  {
      "hex": "07",
      "char": "\u0007",
      "display": "Audible Bell"
  },
  {
      "hex": "08",
      "char": "\b",
      "display": "Backspace"
  },
  {
      "hex": "09",
      "char": "\t",
      "display": "Horizontal Tab"
  },
  {
      "hex": "0A",
      "char": "\n",
      "display": "Line Feed"
  },
  {
      "hex": "0B",
      "char": "\u000b",
      "display": "Vertical Tab"
  },
  {
      "hex": "0C",
      "char": "\f",
      "display": "Form Feed"
  },
  {
      "hex": "0D",
      "char": "\r",
      "display": "Carriage Return"
  },
  {
      "hex": "0E",
      "char": "\u000e",
      "display": "Shift Out"
  },
  {
      "hex": "0F",
      "char": "\u000f",
      "display": "Shift In"
  },
  {
      "hex": "10",
      "char": "\u0010",
      "display": "Data Line Esc."
  },
  {
      "hex": "11",
      "char": "\u0011",
      "display": "Device Control 1"
  },
  {
      "hex": "12",
      "char": "\u0012",
      "display": "Device Control 2"
  },
  {
      "hex": "13",
      "char": "\u0013",
      "display": "Device Control 3"
  },
  {
      "hex": "14",
      "char": "\u0014",
      "display": "Device Control 4"
  },
  {
      "hex": "15",
      "char": "\u0015",
      "display": "Negative ACK"
  },
  {
      "hex": "16",
      "char": "\u0016",
      "display": "Synch. Idle"
  },
  {
      "hex": "17",
      "char": "\u0017",
      "display": "End Transmission Block"
  },
  {
      "hex": "18",
      "char": "\u0018",
      "display": "Cancel"
  },
  {
      "hex": "19",
      "char": "\u0019",
      "display": "End Of Medium"
  },
  {
      "hex": "1A",
      "char": "\u001a",
      "display": "Substitution"
  },
  {
      "hex": "1B",
      "char": "\u001b",
      "display": "Escape"
  },
  {
      "hex": "1C",
      "char": "\u001c",
      "display": "Figures Shift"
  },
  {
      "hex": "1D",
      "char": "\u001d",
      "display": "Group Separator"
  },
  {
      "hex": "1E",
      "char": "\u001e",
      "display": "Record Separator"
  },
  {
      "hex": "1F",
      "char": "\u001f",
      "display": "Unit Separator"
  },
  {
      "hex": "20",
      "char": " ",
      "display": "Blank Space"
  },
  {
      "hex": "21",
      "char": "!",
      "display": "!"
  },
  {
      "hex": "22",
      "char": "\"",
      "display": "\""
  },
  {
      "hex": "23",
      "char": "#",
      "display": "#"
  },
  {
      "hex": "24",
      "char": "$",
      "display": "$"
  },
  {
      "hex": "25",
      "char": "%",
      "display": "%"
  },
  {
      "hex": "26",
      "char": "&",
      "display": "&"
  },
  {
      "hex": "27",
      "char": "'",
      "display": "'"
  },
  {
      "hex": "28",
      "char": "(",
      "display": "("
  },
  {
      "hex": "29",
      "char": ")",
      "display": ")"
  },
  {
      "hex": "2A",
      "char": "*",
      "display": "*"
  },
  {
      "hex": "2B",
      "char": "+",
      "display": "+"
  },
  {
      "hex": "2C",
      "char": ",",
      "display": ","
  },
  {
      "hex": "2D",
      "char": "-",
      "display": "-"
  },
  {
      "hex": "2E",
      "char": ".",
      "display": "."
  },
  {
      "hex": "2F",
      "char": "/",
      "display": "/"
  },
  {
      "hex": "30",
      "char": "0",
      "display": "0"
  },
  {
      "hex": "31",
      "char": "1",
      "display": "1"
  },
  {
      "hex": "32",
      "char": "2",
      "display": "2"
  },
  {
      "hex": "33",
      "char": "3",
      "display": "3"
  },
  {
      "hex": "34",
      "char": "4",
      "display": "4"
  },
  {
      "hex": "35",
      "char": "5",
      "display": "5"
  },
  {
      "hex": "36",
      "char": "6",
      "display": "6"
  },
  {
      "hex": "37",
      "char": "7",
      "display": "7"
  },
  {
      "hex": "38",
      "char": "8",
      "display": "8"
  },
  {
      "hex": "39",
      "char": "9",
      "display": "9"
  },
  {
      "hex": "3A",
      "char": ":",
      "display": ":"
  },
  {
      "hex": "3B",
      "char": ";",
      "display": ";"
  },
  {
      "hex": "3C",
      "char": "<",
      "display": "<"
  },
  {
      "hex": "3D",
      "char": "=",
      "display": "="
  },
  {
      "hex": "3E",
      "char": ">",
      "display": ">"
  },
  {
      "hex": "3F",
      "char": "?",
      "display": "?"
  },
  {
      "hex": "40",
      "char": "@",
      "display": "@"
  },
  {
      "hex": "41",
      "char": "A",
      "display": "A"
  },
  {
      "hex": "42",
      "char": "B",
      "display": "B"
  },
  {
      "hex": "43",
      "char": "C",
      "display": "C"
  },
  {
      "hex": "44",
      "char": "D",
      "display": "D"
  },
  {
      "hex": "45",
      "char": "E",
      "display": "E"
  },
  {
      "hex": "46",
      "char": "F",
      "display": "F"
  },
  {
      "hex": "47",
      "char": "G",
      "display": "G"
  },
  {
      "hex": "48",
      "char": "H",
      "display": "H"
  },
  {
      "hex": "49",
      "char": "I",
      "display": "I"
  },
  {
      "hex": "4A",
      "char": "J",
      "display": "J"
  },
  {
      "hex": "4B",
      "char": "K",
      "display": "K"
  },
  {
      "hex": "4C",
      "char": "L",
      "display": "L"
  },
  {
      "hex": "4D",
      "char": "M",
      "display": "M"
  },
  {
      "hex": "4E",
      "char": "N",
      "display": "N"
  },
  {
      "hex": "4F",
      "char": "O",
      "display": "O"
  },
  {
      "hex": "50",
      "char": "P",
      "display": "P"
  },
  {
      "hex": "51",
      "char": "Q",
      "display": "Q"
  },
  {
      "hex": "52",
      "char": "R",
      "display": "R"
  },
  {
      "hex": "53",
      "char": "S",
      "display": "S"
  },
  {
      "hex": "54",
      "char": "T",
      "display": "T"
  },
  {
      "hex": "55",
      "char": "U",
      "display": "U"
  },
  {
      "hex": "56",
      "char": "V",
      "display": "V"
  },
  {
      "hex": "57",
      "char": "W",
      "display": "W"
  },
  {
      "hex": "58",
      "char": "X",
      "display": "X"
  },
  {
      "hex": "59",
      "char": "Y",
      "display": "Y"
  },
  {
      "hex": "5A",
      "char": "Z",
      "display": "Z"
  },
  {
      "hex": "5B",
      "char": "[",
      "display": "["
  },
  {
      "hex": "5C",
      "char": "\\",
      "display": "\\"
  },
  {
      "hex": "5D",
      "char": "]",
      "display": "]"
  },
  {
      "hex": "5E",
      "char": "^",
      "display": "^"
  },
  {
      "hex": "5F",
      "char": "_",
      "display": "_"
  },
  {
      "hex": "60",
      "char": "`",
      "display": "`"
  },
  {
      "hex": "61",
      "char": "a",
      "display": "a"
  },
  {
      "hex": "62",
      "char": "b",
      "display": "b"
  },
  {
      "hex": "63",
      "char": "c",
      "display": "c"
  },
  {
      "hex": "64",
      "char": "d",
      "display": "d"
  },
  {
      "hex": "65",
      "char": "e",
      "display": "e"
  },
  {
      "hex": "66",
      "char": "f",
      "display": "f"
  },
  {
      "hex": "67",
      "char": "g",
      "display": "g"
  },
  {
      "hex": "68",
      "char": "h",
      "display": "h"
  },
  {
      "hex": "69",
      "char": "i",
      "display": "i"
  },
  {
      "hex": "6A",
      "char": "j",
      "display": "j"
  },
  {
      "hex": "6B",
      "char": "k",
      "display": "k"
  },
  {
      "hex": "6C",
      "char": "l",
      "display": "l"
  },
  {
      "hex": "6D",
      "char": "m",
      "display": "m"
  },
  {
      "hex": "6E",
      "char": "n",
      "display": "n"
  },
  {
      "hex": "6F",
      "char": "o",
      "display": "o"
  },
  {
      "hex": "70",
      "char": "p",
      "display": "p"
  },
  {
      "hex": "71",
      "char": "q",
      "display": "q"
  },
  {
      "hex": "72",
      "char": "r",
      "display": "r"
  },
  {
      "hex": "73",
      "char": "s",
      "display": "s"
  },
  {
      "hex": "74",
      "char": "t",
      "display": "t"
  },
  {
      "hex": "75",
      "char": "u",
      "display": "u"
  },
  {
      "hex": "76",
      "char": "v",
      "display": "v"
  },
  {
      "hex": "77",
      "char": "w",
      "display": "w"
  },
  {
      "hex": "78",
      "char": "x",
      "display": "x"
  },
  {
      "hex": "79",
      "char": "y",
      "display": "y"
  },
  {
      "hex": "7A",
      "char": "z",
      "display": "z"
  },
  {
      "hex": "7B",
      "char": "{",
      "display": "{"
  },
  {
      "hex": "7C",
      "char": "|",
      "display": "|"
  },
  {
      "hex": "7D",
      "char": "}",
      "display": "}"
  },
  {
      "hex": "7E",
      "char": "~",
      "display": "~"
  },
  {
      "hex": "7F",
      "char": "",
      "display": ""
  },
  {
      "hex": "80",
      "char": "",
      "display": ""
  },
  {
      "hex": "81",
      "char": "",
      "display": ""
  },
  {
      "hex": "82",
      "char": "",
      "display": ""
  },
  {
      "hex": "83",
      "char": "",
      "display": ""
  },
  {
      "hex": "84",
      "char": "",
      "display": ""
  },
  {
      "hex": "85",
      "char": "",
      "display": ""
  },
  {
      "hex": "86",
      "char": "",
      "display": ""
  },
  {
      "hex": "87",
      "char": "",
      "display": ""
  },
  {
      "hex": "88",
      "char": "",
      "display": ""
  },
  {
      "hex": "89",
      "char": "",
      "display": ""
  },
  {
      "hex": "8A",
      "char": "",
      "display": ""
  },
  {
      "hex": "8B",
      "char": "",
      "display": ""
  },
  {
      "hex": "8C",
      "char": "",
      "display": ""
  },
  {
      "hex": "8D",
      "char": "",
      "display": ""
  },
  {
      "hex": "8E",
      "char": "",
      "display": ""
  },
  {
      "hex": "8F",
      "char": "",
      "display": ""
  },
  {
      "hex": "90",
      "char": "",
      "display": ""
  },
  {
      "hex": "91",
      "char": "",
      "display": ""
  },
  {
      "hex": "92",
      "char": "",
      "display": ""
  },
  {
      "hex": "93",
      "char": "",
      "display": ""
  },
  {
      "hex": "94",
      "char": "",
      "display": ""
  },
  {
      "hex": "95",
      "char": "",
      "display": ""
  },
  {
      "hex": "96",
      "char": "",
      "display": ""
  },
  {
      "hex": "97",
      "char": "",
      "display": ""
  },
  {
      "hex": "98",
      "char": "",
      "display": ""
  },
  {
      "hex": "99",
      "char": "",
      "display": ""
  },
  {
      "hex": "9A",
      "char": "",
      "display": ""
  },
  {
      "hex": "9B",
      "char": "",
      "display": ""
  },
  {
      "hex": "9C",
      "char": "",
      "display": ""
  },
  {
      "hex": "9D",
      "char": "",
      "display": ""
  },
  {
      "hex": "9E",
      "char": "",
      "display": ""
  },
  {
      "hex": "9F",
      "char": "",
      "display": ""
  },
  {
      "hex": "A0",
      "char": " ",
      "display": " "
  },
  {
      "hex": "A1",
      "char": "¡",
      "display": "¡"
  },
  {
      "hex": "A2",
      "char": "¢",
      "display": "¢"
  },
  {
      "hex": "A3",
      "char": "£",
      "display": "£"
  },
  {
      "hex": "A4",
      "char": "¤",
      "display": "¤"
  },
  {
      "hex": "A5",
      "char": "¥",
      "display": "¥"
  },
  {
      "hex": "A6",
      "char": "¦",
      "display": "¦"
  },
  {
      "hex": "A7",
      "char": "§",
      "display": "§"
  },
  {
      "hex": "A8",
      "char": "¨",
      "display": "¨"
  },
  {
      "hex": "A9",
      "char": "©",
      "display": "©"
  },
  {
      "hex": "AA",
      "char": "ª",
      "display": "ª"
  },
  {
      "hex": "AB",
      "char": "«",
      "display": "«"
  },
  {
      "hex": "AC",
      "char": "¬",
      "display": "¬"
  },
  {
      "hex": "AD",
      "char": "­",
      "display": "­"
  },
  {
      "hex": "AE",
      "char": "®",
      "display": "®"
  },
  {
      "hex": "AF",
      "char": "¯",
      "display": "¯"
  },
  {
      "hex": "B0",
      "char": "°",
      "display": "°"
  },
  {
      "hex": "B1",
      "char": "±",
      "display": "±"
  },
  {
      "hex": "B2",
      "char": "²",
      "display": "²"
  },
  {
      "hex": "B3",
      "char": "³",
      "display": "³"
  },
  {
      "hex": "B4",
      "char": "´",
      "display": "´"
  },
  {
      "hex": "B5",
      "char": "µ",
      "display": "µ"
  },
  {
      "hex": "B6",
      "char": "¶",
      "display": "¶"
  },
  {
      "hex": "B7",
      "char": "·",
      "display": "·"
  },
  {
      "hex": "B8",
      "char": "¸",
      "display": "¸"
  },
  {
      "hex": "B9",
      "char": "¹",
      "display": "¹"
  },
  {
      "hex": "BA",
      "char": "º",
      "display": "º"
  },
  {
      "hex": "BB",
      "char": "»",
      "display": "»"
  },
  {
      "hex": "BC",
      "char": "¼",
      "display": "¼"
  },
  {
      "hex": "BD",
      "char": "½",
      "display": "½"
  },
  {
      "hex": "BE",
      "char": "¾",
      "display": "¾"
  },
  {
      "hex": "BF",
      "char": "¿",
      "display": "¿"
  },
  {
      "hex": "C0",
      "char": "À",
      "display": "À"
  },
  {
      "hex": "C1",
      "char": "Á",
      "display": "Á"
  },
  {
      "hex": "C2",
      "char": "Â",
      "display": "Â"
  },
  {
      "hex": "C3",
      "char": "Ã",
      "display": "Ã"
  },
  {
      "hex": "C4",
      "char": "Ä",
      "display": "Ä"
  },
  {
      "hex": "C5",
      "char": "Å",
      "display": "Å"
  },
  {
      "hex": "C6",
      "char": "Æ",
      "display": "Æ"
  },
  {
      "hex": "C7",
      "char": "Ç",
      "display": "Ç"
  },
  {
      "hex": "C8",
      "char": "È",
      "display": "È"
  },
  {
      "hex": "C9",
      "char": "É",
      "display": "É"
  },
  {
      "hex": "CA",
      "char": "Ê",
      "display": "Ê"
  },
  {
      "hex": "CB",
      "char": "Ë",
      "display": "Ë"
  },
  {
      "hex": "CC",
      "char": "Ì",
      "display": "Ì"
  },
  {
      "hex": "CD",
      "char": "Í",
      "display": "Í"
  },
  {
      "hex": "CE",
      "char": "Î",
      "display": "Î"
  },
  {
      "hex": "CF",
      "char": "Ï",
      "display": "Ï"
  },
  {
      "hex": "D0",
      "char": "Ð",
      "display": "Ð"
  },
  {
      "hex": "D1",
      "char": "Ñ",
      "display": "Ñ"
  },
  {
      "hex": "D2",
      "char": "Ò",
      "display": "Ò"
  },
  {
      "hex": "D3",
      "char": "Ó",
      "display": "Ó"
  },
  {
      "hex": "D4",
      "char": "Ô",
      "display": "Ô"
  },
  {
      "hex": "D5",
      "char": "Õ",
      "display": "Õ"
  },
  {
      "hex": "D6",
      "char": "Ö",
      "display": "Ö"
  },
  {
      "hex": "D7",
      "char": "×",
      "display": "×"
  },
  {
      "hex": "D8",
      "char": "Ø",
      "display": "Ø"
  },
  {
      "hex": "D9",
      "char": "Ù",
      "display": "Ù"
  },
  {
      "hex": "DA",
      "char": "Ú",
      "display": "Ú"
  },
  {
      "hex": "DB",
      "char": "Û",
      "display": "Û"
  },
  {
      "hex": "DC",
      "char": "Ü",
      "display": "Ü"
  },
  {
      "hex": "DD",
      "char": "Ý",
      "display": "Ý"
  },
  {
      "hex": "DE",
      "char": "Þ",
      "display": "Þ"
  },
  {
      "hex": "DF",
      "char": "β",
      "display": "β"
  },
  {
      "hex": "E0",
      "char": "à",
      "display": "à"
  },
  {
      "hex": "E1",
      "char": "á",
      "display": "á"
  },
  {
      "hex": "E2",
      "char": "â",
      "display": "â"
  },
  {
      "hex": "E3",
      "char": "ã",
      "display": "ã"
  },
  {
      "hex": "E4",
      "char": "ä",
      "display": "ä"
  },
  {
      "hex": "E5",
      "char": "å",
      "display": "å"
  },
  {
      "hex": "E6",
      "char": "æ",
      "display": "æ"
  },
  {
      "hex": "E7",
      "char": "ç",
      "display": "ç"
  },
  {
      "hex": "E8",
      "char": "è",
      "display": "è"
  },
  {
      "hex": "E9",
      "char": "é",
      "display": "é"
  },
  {
      "hex": "EA",
      "char": "ê",
      "display": "ê"
  },
  {
      "hex": "EB",
      "char": "ë",
      "display": "ë"
  },
  {
      "hex": "EC",
      "char": "ì",
      "display": "ì"
  },
  {
      "hex": "ED",
      "char": "í",
      "display": "í"
  },
  {
      "hex": "EE",
      "char": "î",
      "display": "î"
  },
  {
      "hex": "EF",
      "char": "ï",
      "display": "ï"
  },
  {
      "hex": "F0",
      "char": "ð",
      "display": "ð"
  },
  {
      "hex": "F1",
      "char": "ñ",
      "display": "ñ"
  },
  {
      "hex": "F2",
      "char": "ò",
      "display": "ò"
  },
  {
      "hex": "F3",
      "char": "ó",
      "display": "ó"
  },
  {
      "hex": "F4",
      "char": "ô",
      "display": "ô"
  },
  {
      "hex": "F5",
      "char": "õ",
      "display": "õ"
  },
  {
      "hex": "F6",
      "char": "ö",
      "display": "ö"
  },
  {
      "hex": "F7",
      "char": "÷",
      "display": "÷"
  },
  {
      "hex": "F8",
      "char": "ø",
      "display": "ø"
  },
  {
      "hex": "F9",
      "char": "ù",
      "display": "ù"
  },
  {
      "hex": "FA",
      "char": "ú",
      "display": "ú"
  },
  {
      "hex": "FB",
      "char": "û",
      "display": "û"
  },
  {
      "hex": "FC",
      "char": "ü",
      "display": "ü"
  },
  {
      "hex": "FD",
      "char": "ý",
      "display": "ý"
  },
  {
      "hex": "FE",
      "char": "þ",
      "display": "þ"
  },
  {
      "hex": "FF",
      "char": "ÿ",
      "display": "ÿ"
  }
]
